import React from 'react'
import { Platform, Text, View, useWindowDimensions } from 'react-native'
import type { StyleProp, TextStyle } from 'react-native'
import { renderLogText, renderNativeDiceComparison } from '../../lib/renderLogText'
import type { NameHighlight } from '../../lib/renderLogText'
import { splitLogDiceComparison } from '../../lib/logTextLayout'

interface Props {
  text: string
  diceSize: number
  fontSize: number
  color: string
  highlights?: NameHighlight[]
  className?: string
  style?: StyleProp<TextStyle>
  numberOfLines?: number
}

/** Shared by full, compact and attack logs. Native rolls need ordinary layout
 * boxes: inline SVG attachments sit above the text baseline and can clip the
 * following loss summary when a Text line has a fixed height. */
export function FormattedLogText({ text, diceSize, fontSize, color, highlights, className, style, numberOfLines }: Props) {
  // Subscribe to system text-size changes; native dice use the same scale.
  useWindowDimensions()
  const comparison = Platform.OS === 'web' ? null : splitLogDiceComparison(text)
  if (!comparison) {
    return (
      <Text className={className} style={style} numberOfLines={numberOfLines}>
        {renderLogText(text, diceSize, highlights, color, fontSize)}
      </Text>
    )
  }
  const textStyle = [style, { fontSize, lineHeight: Math.ceil(fontSize * 1.45), color, includeFontPadding: false }]
  return (
    <View>
      {!!comparison.description && (
        <Text className={className} style={textStyle} numberOfLines={numberOfLines}>
          {renderLogText(comparison.description, diceSize, highlights, color, fontSize)}
        </Text>
      )}
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', columnGap: 4, rowGap: 2, paddingVertical: 2 }}>
        {!!comparison.prefix && <Text className={className} style={textStyle}>{comparison.prefix}</Text>}
        {renderNativeDiceComparison(comparison.attacker, comparison.defender, fontSize, color)}
        {!!comparison.suffix && (
          <Text className={className} style={textStyle}>
            {comparison.suffix}
          </Text>
        )}
      </View>
    </View>
  )
}
